window.StickerCovenConfigurator =
  window.StickerCovenConfigurator || {};

window.StickerCovenConfigurator.UploadService =
  class UploadService {
    constructor(section) {
      this.section = section;

      this.container =
        section.querySelector(
          ".upload-placeholder"
        ) || section;

      this.observer = null;
      this.observeTimer = null;
      this.submittedUploads = new Set();
    }

    getFields() {
      if (!this.container) {
        return [];
      }

      return Array.from(
        this.container.querySelectorAll(
          "input[name], select[name], textarea[name]"
        )
      );
    }

    getPropertyName(field) {
      const name =
        field?.getAttribute("name") || "";

      const match = name.match(
        /^properties\[(.+)\]$/
      );

      return match ? match[1] : "";
    }

    isUploadPropertyName(name) {
      return /^upload(?:[_\s-]?\d+)?$/i.test(
        String(name).trim()
      );
    }

    extractCloudliftUrls(value) {
      const stringValue =
        String(value || "").trim();

      if (!stringValue) {
        return [];
      }

      /*
       * A multiple-file field may contain more than one
       * Cloudlift URL in plain text, JSON, or a list.
       */
      const matches = stringValue.match(
        /https?:\/\/upload\.cloudlift\.app\/[^\s"',\]\)]+/gi
      );

      return matches || [];
    }

    getUploadValues() {
      const uploads = [];
      const seenValues = new Set();

      const addUpload = (value) => {
        const cleanedValue =
          String(value || "").trim();

        if (
          !cleanedValue ||
          seenValues.has(cleanedValue)
        ) {
          return;
        }

        seenValues.add(cleanedValue);
        uploads.push(cleanedValue);
      };

      this.getFields().forEach((field) => {
        const propertyName =
          this.getPropertyName(field);

        const rawValue =
          String(field.value || "").trim();

        if (!rawValue) {
          return;
        }

        const cloudliftUrls =
          this.extractCloudliftUrls(
            rawValue
          );

        /*
         * When URLs are present, add every individual
         * file rather than retaining only the first one.
         */
        if (cloudliftUrls.length > 0) {
          cloudliftUrls.forEach(addUpload);
          return;
        }

        /*
         * Preserve upload fields even when Cloudlift
         * changes the URL format later.
         */
        if (
          this.isUploadPropertyName(
            propertyName
          )
        ) {
          addUpload(rawValue);
        }
      });

      return uploads.filter(
      (value) =>
        !this.submittedUploads.has(
          value
        )
    );
    }

    markSubmitted(values = []) {
      values.forEach((value) => {
        const cleanedValue =
          String(value || "").trim();

        if (cleanedValue) {
          this.submittedUploads.add(
            cleanedValue
          );
        }
      });
    }

    unmarkSubmitted(values = []) {
      values.forEach((value) => {
        const cleanedValue =
          String(value || "").trim();

        if (cleanedValue) {
          this.submittedUploads.delete(
            cleanedValue
          );
        }
      });
    }

    getCartProperties() {
      const properties = {};

      this.getUploadValues().forEach(
        (uploadValue, index) => {
          properties[
            `upload_${index + 1}`
          ] = uploadValue;
        }
      );

      return properties;
    }

    hasUpload() {
      return (
        this.getUploadValues().length > 0
      );
    }

    observe(callback) {
      if (
        typeof callback !== "function" ||
        !this.container
      ) {
        return;
      }

      const notify = () => {
        window.clearTimeout(
          this.observeTimer
        );

        this.observeTimer =
          window.setTimeout(() => {
            callback(
              this.getCartProperties()
            );
          }, 100);
      };

      this.container.addEventListener(
        "input",
        notify
      );

      this.container.addEventListener(
        "change",
        notify
      );

      this.observer =
        new MutationObserver(notify);

      this.observer.observe(
        this.container,
        {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: [
            "value",
            "name"
          ]
        }
      );
    }

    debugUploads() {
      const properties =
        this.getCartProperties();

      console.group(
        "Sticker Coven — Upload Lift files"
      );

      console.table(properties);
      console.log(
        "Upload count:",
        Object.keys(properties).length
      );

      console.groupEnd();

      return properties;
    }
  };